(() => {
  if (window.__jfKlaviyoScrollGuardInstalled) return;
  window.__jfKlaviyoScrollGuardInstalled = true;

  const lockClass = 'klaviyo-prevent-body-scrolling';
  const modalSelector = '[data-kl-scroll-locking-modal="true"]';
  const checkInterval = 200;
  const missingModalGracePeriod = 600;
  let checkTimer;
  let missingModalSince = null;

  function isVisible(modal) {
    if (!modal.isConnected || modal.getClientRects().length === 0) return false;

    for (let element = modal; element; element = element.parentElement) {
      if (element.hidden) return false;

      const style = window.getComputedStyle(element);
      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.visibility === 'collapse' ||
        style.contentVisibility === 'hidden'
      ) return false;
    }

    return true;
  }

  function reconcile() {
    window.clearTimeout(checkTimer);
    checkTimer = undefined;

    const body = document.body;
    if (!body || !body.classList.contains(lockClass)) {
      missingModalSince = null;
      return;
    }

    const modalIsOpen = Array.from(document.querySelectorAll(modalSelector)).some(isVisible);

    if (modalIsOpen) {
      missingModalSince = null;
    } else {
      const now = window.performance.now();
      if (missingModalSince === null) missingModalSince = now;

      if (now - missingModalSince >= missingModalGracePeriod) {
        body.classList.remove(lockClass);
        missingModalSince = null;
        return;
      }
    }

    checkTimer = window.setTimeout(reconcile, checkInterval);
  }

  function init() {
    const observer = new MutationObserver(reconcile);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('klaviyoForms', (event) => {
      if (event.detail?.type === 'open') missingModalSince = null;
      reconcile();
    });
    window.addEventListener('pageshow', reconcile);
    window.addEventListener('focus', reconcile);
    document.addEventListener('visibilitychange', reconcile);
    document.addEventListener('shopify:section:load', reconcile);
    document.addEventListener('shopify:section:unload', reconcile);

    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
